import * as React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { withApollo } from "react-apollo";

import AppComponent from "./component/App";
import { PublisherSale, PublisherAnalytical } from "./component/publisher";
import { Main } from "./component/shared";
import { BookstoreSale, BookstoreAnalytical } from "./component/bookstore";
import { DistributorSale, DistributorAnalytical } from "./component/distributor";
import { AccessReport } from "./component/administration";
import { Private } from "./services/PrivateRoute";
import { UsersRegister } from "./component/administration/registers/users/UsersRegister";
import { BookstoresRegister } from "./component/administration/registers/bookstores/BookstoresRegister";
import { Permission } from "./component/administration/permissions/Permission";
import { Analytics } from "./component/administration/analytics/Analytics";
import { DataLoad } from "./component/administration/data-load/DataLoad";
import { ProductGrouping } from "./component/administration/registers/product-grouping/ProductGrouping";
import { VejaPanel } from "./component/panel/veja/VejaPanel";
import { PublishNewsPanel } from "./component/panel/publish-news/PublishNewsPanel";
import { GeneralSalesPanel } from "./component/panel/general/GeneralSalesPanel";
import { BookinfoPremiumBestSellerPanel } from "./component/panel/bookinfo-premium/BookinfoPremiumBestSellerPanel";
import { MarketShares } from "./component/market";
import { MarketSharesBookstore } from "./component/market";
import { ProductCategoryCorrection } from "./component/administration/registers/product-category-correction/ProductCategoryCorrection";
import { ProductBlacklist } from "./component/administration/registers/product-blacklist/ProductBlacklist";
import { ConsultingPublisher } from "./component/consulting/publisher/ConsultingPublisher";

class Router extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  public render() {
    return (
      <BrowserRouter>
        <Switch>
          <Route exact={true} path="/" component={AppComponent} />
          <Route path='/dashboard' component={Private(Main)} />
          
          <Route path='/bookstore/sale' component={Private(BookstoreSale)} />
          <Route path='/bookstore/analytical' component={Private(BookstoreAnalytical)} />
          
          <Route path='/distributor/sale' component={Private(DistributorSale)} />
          <Route path='/distributor/analytical' component={Private(DistributorAnalytical)} />
          
          <Route path='/publisher/sale' component={Private(PublisherSale)} />
          <Route path='/publisher/analytical' component={Private(PublisherAnalytical)} />
          
          <Route path='/administration/accessreport' component={Private(AccessReport)} />
          <Route path='/administration/users-register' component={Private(UsersRegister)} />
          <Route path='/administration/bookstores-register' component={Private(BookstoresRegister)} />
          <Route path='/administration/permission' component={Private(Permission)} />
          <Route path='/administration/analytics' component={Private(Analytics)} />
          <Route path='/administration/dataLoad' component={Private(DataLoad)} />
          <Route path='/administration/product-group-register' component={Private(ProductGrouping)} />
          <Route path='/administration/product-category-correction' component={Private(ProductCategoryCorrection)} />
          <Route path='/administration/product-blacklist' component={Private(ProductBlacklist)} />
          
          <Route path='/panel/veja' component={Private(VejaPanel)} />
          <Route path='/panel/publish-news' component={Private(PublishNewsPanel)} />
          <Route path='/panel/general-sales' component={Private(GeneralSalesPanel)} />
          <Route path='/panel/bookinfo-premium-sales' component={Private(BookinfoPremiumBestSellerPanel)} />
          
          <Route path='/market/shares/general' component={Private(MarketShares)} />
          <Route path='/market/shares/bookstores' component={Private(MarketSharesBookstore)} />

          <Route path='/consulting/publisher' component={Private(ConsultingPublisher)} />
          
        </Switch>
      </BrowserRouter>
    );
  }
}

export default withApollo(Router);



// WEBPACK FOOTER //
// ./src/Router.tsx